<template>
  <div class="card flex flex-col items-start gap-2">
    <div v-if="label">
      <label
        :for="label"
        :class="labelClass"
        class="text-text-primary text-sm font-medium dark:text-dark-secondary"
      >
        {{ label }}
      </label>
      <span v-if="required" class="text-text-error"> *</span>
    </div>
    <div
      id="test-checkbox"
      :class="[
        layout === 'vertical'
          ? 'flex flex-col items-start gap-2'
          : 'grid grid-cols-4 gap-x-6 gap-y-1',
      ]"
    >
      <div
        v-for="option in options"
        :key="option.id"
        class="flex items-center gap-1"
      >
        <Checkbox
          v-model="selected"
          :inputId="'checkbox_' + option.id"
          :value="option.id"
          :disabled="disabled"
          :invalid="isError"
        />
        <label class="dark:text-white" :for="'checkbox_' + option.id">
          {{ option.name }}
        </label>
      </div>
    </div>
    <!-- Mensaje de error debajo de todos los checkboxes -->
    <p
      v-if="error"
      id="test-checkbox-error"
      class="text-helper-text text-[12px] -mt-3.75"
    >
      <font-awesome-icon
        icon="fa-solid fa-circle-xmark"
        class="text-helper-text"
      />
      {{ error }}
    </p>
  </div>
</template>

<script setup>
import Checkbox from "primevue/checkbox";
import { computed } from "vue";

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: "",
  },
  layout: {
    type: String,
    default: "horizontal",
    validator: (value) => ["horizontal", "vertical"].includes(value),
  },
  label: {
    type: String,
    required: false,
    default: "",
  },
  required: {
    type: Boolean,
    default: true,
  },
});

const isError = computed(() => props.error.length > 0);

// Define el modelo para almacenar las opciones seleccionadas
const selected = defineModel({
  type: Array,
  default: () => [],
});
</script>
